import React from "react";
import Ingredient from "../Ingredient";
import whole from "../../assets/images/ingredients/Onion_Peeled.png";
import sliced from "../../assets/images/ingredients/Onion_Diced_Raw_Group.png";

const Onion = ({ onClick, changeable=true, changed, hideable=true }) => {
    const handleClick = (event) => {
        event.stopPropagation();
        if (onClick) {
            onClick(event);
        }
    };
    return (
        <Ingredient
            name="Onion"
            image={[whole, sliced]}
            changeable={changeable}
            changed={changed}
            hideable={hideable}
            onClick={handleClick}
        />
    );
};

export default Onion;